<a *ngIf="value[CONSTANTS.name]" (click)="openElementDialog()" class="adb-element-link">{{ value[CONSTANTS.name] }}</a>